import React from "react";
import "../Style/Footer.css";

import {
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
  FaFacebook,
} from "react-icons/fa";

import logo from "../assets/logo.png";
import award1 from "../assets/people.png";
import award2 from "../assets/innovation.png";
import award3 from "../assets/growth.png";

const Footer = () => {
  // Social media links configuration
  const socialLinks = [
    {
      name: "Instagram",
      icon: FaInstagram,
      url: "https://www.instagram.com/mpeoples_official?igsh=dnpibzNmMmtsc3Bo",
      color: "#E4405F",
    },
    {
      name: "LinkedIn",
      icon: FaLinkedin,
      url: "https://www.linkedin.com/company/mpeoples-business-solutions-private-limited/",
      color: "#0A66C2",
    },
    {
      name: "YouTube",
      icon: FaYoutube,
      url: "https://youtube.com/@readers_menu?si=v-bSdlSU1sblA0xM",
      color: "#FF0000",
    },
    {
      name: "WhatsApp",
      icon: FaWhatsapp,
      url: "https://wa.me/919487812715",
      color: "#25D366",
    },
    {
      name: "Facebook",
      icon: FaFacebook,
      url: "https://www.facebook.com/share/1Ltt6HP6Rr/",
      color: "#1877F2",
    },
  ];

  return (
    <footer className="footer">
      {/* Background pattern */}
      <div className="footer-pattern" aria-hidden="true"></div>

      {/* ================= TOP SECTION ================= */}
      <div className="footer-top">
        {/* ================= BRAND ================= */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img
              src={logo}
              alt="MPeoples"
              className="footer-logo-img"
            />

            <span className="footer-logo-text">MPeoples</span>
          </div>

          <p className="footer-desc">
            Transforming ideas into powerful digital products through
            user-focused design and scalable development solutions for
            businesses worldwide.
          </p>

          {/* Awards */}
          <div className="footer-awards">
            <img src={award1} alt="Award 1" />
            <img src={award2} alt="Award 2" />
            <img src={award3} alt="Award 3" />
          </div>
        </div>

        {/* ================= SERVICES ================= */}
        <div className="footer-col">
          <h4>Services</h4>

          <ul>
            <li>
              <a href="/uiux-design">UI / UX Design</a>
            </li>

            <li>
              <a href="/web-development">Web Development</a>
            </li>

            <li>
              <a href="/app-development">App Development</a>
            </li>

            <li>
              <a href="/saas-development">SaaS Development</a>
            </li>

            <li>
              <a href="/digital-marketing">Digital Marketing</a>
            </li>

            <li>
              <a href="/graphic-design">Graphic Design</a>
            </li>

            <li>
              <a href="/video-editing">Video Editing</a>
            </li>
          </ul>
        </div>

        {/* ================= RESOURCES ================= */}
        <div className="footer-col">
          <h4>Resources</h4>

          <ul>
            <li>
              <a href="/case-study">Case Study</a>
            </li>

            <li>
              <a href="/blogs-page">Blog</a>
            </li>
          </ul>

          <h4 style={{ marginTop: "20px" }}>Our Products</h4>

          <ul>
            <li>
              <a href="/#our-products">Our Products</a>
            </li>
          </ul>
        </div>

        {/* ================= COMPANY ================= */}
        <div className="footer-col">
          <h4>Company</h4>

          <ul>
            <li>
              <a href="/about-us">About Us</a>
            </li>

            <li>
              <a href="/team-page">Team</a>
            </li>

            <li>
              <a href="/career-page">Career</a>
            </li>
          </ul>

          {/* ================= SOCIAL ICONS ================= */}
          <div className="footer-socials">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;

              return (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label={social.name}
                  title={social.name}
                >
                  <Icon />
                </a>
              );
            })}
          </div>
        </div>
      </div>

      {/* ================= NEWSLETTER ================= */}
      {/*
      <div className="footer-newsletter">
        <span>Get updates from MPeoples</span>

        <div>
          <input
            type="email"
            placeholder="Enter your email address"
            aria-label="Email address"
          />

          <button>
            Subscribe
            <FaArrowRight className="newsletter-icon" />
          </button>
        </div>
      </div>
      */}

      {/* ================= BOTTOM ================= */}
      <div className="footer-bottom">
        <span>© 2026 MPeoples. All rights reserved.</span>

        <div>
          <a href="/termsandconditions/">Terms</a>

          <a href="/privacypolicy/">Privacy</a>

          <a href="/paymentpolicy/">Payment Policy</a>

          <a href="/cookies-policy/">Cookies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;